import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_PRODUCTION_MOLD',
  });
  const fetchData = function () {
    if (params && JSON.stringify(params) !== '{}' && params.product_id) {
      let url = `/api/product_mold_relation/${params.product_id}`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
  }, [params]);

  return [data || {}, exec, isRequestSuccessed];
});
